import {
  User,
  UserAuth,
  UserPreferences,
  UserCreateParams,
  PaginateUserParams,
  UserReservablesConfig,
  SimpleUser,
} from '@go-shared/types/user';
import { apiDelete, apiDownload, apiGet, apiPost, apiPut } from '.';
import qs from 'query-string';
import { PaginationResult } from '@go-shared/types/pagination';

export async function crewlogIn(username: string, password: string): Promise<User & UserAuth> {
  return apiPost('/user/login/crew', { username, password }, {}, false);
}

export async function logIn(username: string, password: string): Promise<User & UserAuth> {
  return apiPost('/user/login', { username, password }, {}, false, false);
}

export async function getUser(): Promise<User> {
  return apiGet('/user/me');
}

export async function createUser(user: UserCreateParams): Promise<User> {
  return apiPost('/user', user);
}

export async function deleteUser(userId: string): Promise<User> {
  return apiDelete(`/user/${userId}`);
}

export async function updateUser(user: User) {
  return apiPut(`/user/${user._id}`, user);
}

export async function generateRecoveryToken(user: User): Promise<string> {
  return apiGet(`/user-recovery/${user._id}`);
}

export async function logInWithRecoveryToken(
  username: string,
  newPassword: string,
  recoveryToken: string
): Promise<User & UserAuth> {
  return apiPost('/user-recovery', { username, newPassword, recoveryToken }, {}, false, false);
}

export async function getUsers(property?: string): Promise<User[]> {
  const url = property ? `/property/${property}/user` : `/user`;
  return apiGet(url);
}

export async function getSimpleUsers(property?: string): Promise<SimpleUser[]> {
  const url = property ? `/property/${property}/user-simple` : `/user-simple`;
  return apiGet(url);
}

export async function paginateUsers(params: PaginateUserParams): Promise<PaginationResult<User>> {
  return apiGet(`/user/paginate?${qs.stringify(params)}`);
}

export async function getUserById(userId: string): Promise<User> {
  return apiGet(`/user/${userId}`);
}

export async function getManyUsersById(users: string[]): Promise<User[]> {
  return apiGet(`/user`, { users });
}

export const getLicenseAgreement = () => {
  return apiGet<{ license_text: string }>('/license-agreement');
};

export const acceptLicenseAgreement = () => {
  return apiPost<User>('/license-agreement', { accepted: true });
};

export async function updateUserPreferences(preferences: UserPreferences) {
  return apiPut('/user/me/preferences', preferences);
}

export async function updateReservablesConfig(config: UserReservablesConfig) {
  return apiPut('/user/me/reservables-config', config);
}

export async function exportUsers() {
  return apiDownload('/user-export');
}
